import { Component, OnInit } from '@angular/core';
import { ApiService } from '../_services';
import { MessagingService } from '../core/messaging/messaging.service';
import { IChangeCallback } from '../_entities';


@Component({
	selector: 'user-settings',
	template: require('./user-settings.component.html')
})
export class UserSettingsComponent implements OnInit {

	constructor(
		private api: ApiService,
		private messaging: MessagingService
	) { }

	ngOnInit(): void {
		this.api.profile.get().then(p => this.userProfile = p);
	}

	userProfile;

	storeMenuModes = [{ id: 0, name: "Geographic Region" }, { id: 1, name: "Own Region" }];

	public onProfileChange(event: IChangeCallback<any>) {

		this.userProfile[event.id] = event.newValue;

		this.api.profile.save(this.userProfile).then(p => {
			this.userProfile = p;
			this.messaging.publish("refresh-main-menu", null);
			event.resolve();
		},
			error => {
				event.reject(error);
			});
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/user-settings.component.ts